var r=function(r){return function(t,e,n){for(var a=-1,f=Object(t),u=n(t),o=u.length;o--;){var c=u[r?o:++a];if(!1===e(f[c],c,f))break}return t}};export{r as default};
//# sourceMappingURL=_createBaseFor.js.map
